import React, { useState, useEffect } from 'react';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';
import AppContent from './AppContent';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import adminApi from 'services/adminApi';

const Dashboard = () => {
  const [content, setContent] = useState(() => {
    const savedContent = localStorage.getItem('dashboardContent');
    return savedContent !== null ? parseInt(savedContent, 10) : 1;
  });
  const [isAuth, setIsAuth] = useState(false);
  const history = useHistory();

  const checkToken = async () => {
    const res = await adminApi({ url: '/auth/check-token' });
    const result = await res.json();
    if (result.isSuccess) {
      setIsAuth(true);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');
    if (!userId || !token) history.push('/login');

    checkToken();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    localStorage.setItem('dashboardContent', content);
  }, [content]);

  if (!isAuth) return null;

  return (
    <div
      style={{ display: 'flex', height: '100vh', backgroundColor: '#80808017' }}
    >
      <AppSidebar setContent={setContent} />
      <div style={{ flex: 1, padding: '1rem', overflow: 'auto' }}>
        <AppHeader content={content} />
        <AppContent content={content} />
      </div>
    </div>
  );
};

export default Dashboard;
